import * as types from 'store/mutation-types'
import {
  fetchWatchListGroup,
  reqAddWatchListGroup,
  reqRemoveWatchListGroup,
  reqSetWatchListGroup,
  reqUpdateWatchListGroup
} from 'apis/stock'

const state = {
  displayBookmarkManager: false,
  groupList: [],
  topGroupId: '',
  stocksToAdd: [],
  bookmarkPrompt: null,
  displayMode: 'allStockList',
  currentSelectGroup: {}
}

const getters = {
  displayBookmarkManager(state) {
    return state.displayBookmarkManager
  },
  watchGroupList(state) {
    return state.groupList
  },
  watchGroupBookmarkPrompt(state) {
    return state.bookmarkPrompt
  },
  currentSelectGroup(state) {
    return state.currentSelectGroup
  }
}

const mutations = {
  [types.LOAD_GROUP_LIST](state, items) {
    const topGroup = items.filter(group => {
      return group.rank === 0
    })[0]
    state.groupList = items
    if (topGroup) state.topGroupId = topGroup.group
  },
  [types.SAVE_STOCKS_TO_ADD](state, stockList) {
    state.stocksToAdd = stockList
  },
  [types.CLEAR_ADD_STOCKS_GROUP](state) {
    state.stocksToAdd = []
  },
  [types.BOOKMARK_PROMPT](state, payload) {
    state.bookmarkPrompt = payload
  },
  [types.CLEAR_BOOKMARK_PROMPT](state) {
    state.bookmarkPrompt = null
  },
  [types.SHOW_GROUP_MODIFY](state) {
    state.displayMode = 'groupList'
  },
  [types.TOGGLE_BOOKMARK_MANAGER](state) {
    if (state.displayBookmarkManager) {
      state.displayBookmarkManager = false
      state.displayMode = 'allStockList'
    } else {
      state.displayBookmarkManager = true
    }
  },
  [types.SET_CURRENT_GROUP](state, group) {
    state.currentSelectGroup = group
  },
  [types.CLEAR_CURRENT_GROUP](state) {
    state.currentSelectGroup = {}
  }
}

const actions = {
  loadGroupList({ commit, dispatch, state }) {
    return fetchWatchListGroup().then(response => {
      commit(types.LOAD_GROUP_LIST, response.data.items || [])
      return state.groupList
    })
  },
  submitGroupName({ commit, state, dispatch }, nameInfo) {
    // Create pipeline
    if (nameInfo.type === 'create') {
      const items = [nameInfo.name]
      // Create Group with Stocks pipeline
      if (state.stocksToAdd.length > 0) {
        return reqAddWatchListGroup(items).then(response => {
          if (response.data.ret === 0) {
            const groupId = response.data.items[0]
            dispatch('addStocksToGroup', groupId)
          }
          return response.data
        })
      } else {
        // Create Group without stocks pipeline
        return reqAddWatchListGroup(items).then(response => {
          if (response.data.ret === 0) {
            commit(types.CLEAR_BOOKMARK_PROMPT)
            dispatch('loadGroupList')
          }
          return response.data
        })
      }
    } else {
      // Change group name pipeline
      const items = [
        {
          name: nameInfo.name,
          group: nameInfo.groupId
        }
      ]
      return reqSetWatchListGroup(items).then(response => {
        if (response.data.ret === 0) {
          commit(types.CLEAR_BOOKMARK_PROMPT)
          dispatch('loadGroupList')
        }
        return response.data
      })
    }
  },
  saveNewGroupListOrder({ commit, state, dispatch }, list) {
    commit(types.LOAD_GROUP_LIST, list)
    const newList = list.map(val => {
      return {
        group: val.group,
        name: val.name
      }
    })
    reqUpdateWatchListGroup(newList).then(() => {
      dispatch('loadGroupList')
    })
  },
  deleteWatchGroup({ commit, dispatch, state }, groupId) {
    if (groupId !== '0') {
      reqRemoveWatchListGroup([groupId]).then(() => {
        if (groupId === state.currentSelectGroup.group) {
          commit(types.CLEAR_CURRENT_GROUP)
        }
        dispatch('loadGroupList')
      })
    }
  },
  saveStocksToAdd({ commit, dispatch, state }, stockList) {
    commit(types.SAVE_STOCKS_TO_ADD, stockList)
  },
  addStocksToGroup({ commit, dispatch, state }, groupId) {
    const payload = state.stocksToAdd.map(symbol => {
      return {
        symbol: symbol,
        group: groupId
      }
    })
    dispatch('addToWatchlist', payload)
      .then(() => dispatch('loadGroupList'))
      .then(() => dispatch('clearBookmarkPrompt'))
  },
  discardTempSaveStocks({ commit, state }) {
    commit(types.CLEAR_ADD_STOCKS_GROUP)
  },
  bookmarksGoBack({ commit, state, dispatch }) {
    const groupId = state.currentSelectGroup.group || state.topGroupId
    const watchViewPayload = {
      view: 'watch-group-view',
      value: groupId
    }
    dispatch('updateViewSettings', watchViewPayload)
    const payload = {
      view: 'watchlist',
      value: ['default', 'desc']
    }
    dispatch('updateViewSettings', payload)
    dispatch('initWatchlist', groupId).then(() => {
      commit(types.TOGGLE_BOOKMARK_MANAGER)
    })
  },
  bookmarkPrompt({ commit }, payload) {
    /* payload template:
     * const payload = {
     *  type: (createName, changeName, addStocks)
     *  oldGroupInfo: (Object)
     * }
     */
    commit(types.BOOKMARK_PROMPT, payload)
  },
  clearBookmarkPrompt({ commit }) {
    commit(types.CLEAR_ADD_STOCKS_GROUP)
    commit(types.CLEAR_BOOKMARK_PROMPT)
  },
  openGroupStocks({ commit, dispatch }, group) {
    dispatch('initWatchlist', group.group).then(() => {
      commit(types.TOGGLE_BOOKMARK_MANAGER)
    })
  },
  toggleBookmarkManager({ commit }) {
    commit(types.TOGGLE_BOOKMARK_MANAGER)
  },
  saveCurSelectGroup({ commit }, group) {
    commit(types.SET_CURRENT_GROUP, group)
  },
  showGroupModify({ commit }) {
    commit(types.SHOW_GROUP_MODIFY)
  }
}

export default { state, getters, mutations, actions }
